import React from "react";
import { PostHeaderContent } from "./index";
import TableOfContents from "../TableOfContents";
import {
  ContenuDynamiqueForm,
  ContenuDynamiqueTexte,
  ContenuDynamiqueConseil,
  ContenuDynamiqueLien,
  ContenuDynamiqueTexteImage,
  ContenuDynamiqueCarte,
  ContenuDynamiqueImage,
} from "../dynamic";

const PostContent = ({ post, acf, src }) => {
  return (
    <div className={"post " + post.slug}>
      <section className="section content">
        {src !== null && <PostHeaderContent acf={acf} post={post} src={src} />}
        <main>
          <div className="content-layout">
            <div className="table-of-contents">
              <TableOfContents contentData={acf?.contenudynamique} />
            </div>
            <div className="content-main">
              <div className="inner">
                {acf?.contenudynamique?.map((data, key) => {
                  switch (data.fieldGroupName) {
                    case "post_Acfpageinterne_Contenudynamique_Texte":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueTexte data={data} />
                        </div>
                      );
                    case "post_Acfpageinterne_Contenudynamique_Texteimage":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueTexteImage data={data} />
                        </div>
                      );
                    case "post_Acfpageinterne_Contenudynamique_Image":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueImage data={data} />
                        </div>
                      );
                    case "post_Acfpageinterne_Contenudynamique_Carte":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueCarte data={data} />
                        </div>
                      );
                    case "post_Acfpageinterne_Contenudynamique_Conseil":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueConseil data={data} />
                        </div>
                      );
                    /*case "post_Acfpageinterne_Contenudynamique_Lien":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueLien data={data} />
                        </div>
                      );*/
                    case "post_Acfpageinterne_Contenudynamique_Form":
                      return (
                        <div key={key} data-content-index={key}>
                          <ContenuDynamiqueForm />
                        </div>
                      );
                    default:
                      return null;
                  }
                })}
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default PostContent;
